module.exports = __webpack_public_path__ + "img/welding-1.c24cd954.jpg";